import LookupsTypes from './LookupsTypes';

const initialState = {
  linerList: { data: [], isFetched: false, progressing: false },
  measurementUnits: { data: [], isFetched: false, progressing: false },
  paymentTypes: { data: [], isFetched: false, progressing: false },
  pricingBasis: { data: [], isFetched: false, progressing: false },
  pricingTypes: { data: [], isFetched: false, progressing: false },
  taxTypes: { data: [], isFetched: false, progressing: false },
  vendorFieldsVisibility: {
    currentCustomerKey: 0,
    data: [],
    isFetched: false,
    progressing: false,
    success: false,
  },
};

const LookupsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LookupsTypes.GET_TAX_TYPES_TYPES: {
      return {
        ...state,
        taxTypes: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    }
    case LookupsTypes.SET_TAX_TYPES_TYPES: {
      return {
        ...state,
        taxTypes: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };
    }

    case LookupsTypes.GET_PRICING_BASIS: {
      return {
        ...state,
        pricingBasis: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    }
    case LookupsTypes.SET_PRICING_BASIS: {
      return {
        ...state,
        pricingBasis: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };
    }

    case LookupsTypes.GET_PRICING_TYPES: {
      return {
        ...state,
        pricingTypes: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    }
    case LookupsTypes.SET_PRICING_TYPES: {
      return {
        ...state,
        pricingTypes: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };
    }

    case LookupsTypes.GET_MEASUREMENT_UNIT_TYPES: {
      return {
        ...state,
        measurementUnits: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    }
    case LookupsTypes.SET_MEASUREMENT_UNIT_TYPES: {
      return {
        ...state,
        measurementUnits: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };
    }

    case LookupsTypes.GET_LINER_CODES: {
      return {
        ...state,
        linerList: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    }
    case LookupsTypes.SET_LINER_CODES: {
      return {
        ...state,
        linerList: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };
    }

    case LookupsTypes.GET_PAYMENT_TYPES:
      return {
        ...state,
        paymentTypes: {
          data: [],
          isFetched: true,
          progressing: true,
        },
      };
    case LookupsTypes.SET_PAYMENT_TYPES:
      return {
        ...state,
        paymentTypes: {
          data: payload,
          isFetched: true,
          progressing: false,
        },
      };

    case LookupsTypes.GET_VENDOR_FIELDS_VISIBILITY:
      return {
        ...state,
        vendorFieldsVisibility: {
          currentCustomerKey: payload,
          data: [],
          isFetched: true,
          progressing: true,
          success: false,
        },
      };
    case LookupsTypes.SET_VENDOR_FIELDS_VISIBILITY:
      return {
        ...state,
        vendorFieldsVisibility: {
          data: payload,
          isFetched: true,
          progressing: false,
          success: true,
        },
      };

    default:
      return state;
  }
};

export default LookupsReducer;
